import * as path from "../paths";
import { client } from "../client";

export const getLatestNews = () => {
  return client
    .get(path.GET_LATEST_NEWS)
    .then((result) => result)
    .catch((err) => err.response);
};

export const getAllEvents = (city) => {
  return client
    .get(`${path.GET_ALL_EVENTS}?city=${city}`)
    .then((result) => result)
    .catch((err) => err.response);
};
export const getCommunityEvents = () => {
  return client
    .get(`${path.GET_COMMUNITY_EVENTS}`)
    .then((result) => result)
    .catch((err) => err.response);
};
export const getStocks = (symbols) => {
  return client
    .get(`${path.GET_STOCKS}?symbols=${symbols}`)
    .then((result) => result)
    .catch((err) => err.response);
};
export const postCommunityEvent = (formData) => {
  return client
    .post(path.CREATE_EVENT, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((result) => result)
    .catch((err) => err.response);
};
export const deleteCommunityEvent = (eventId) => {
  return client
    .delete(`${path.GET_COMMUNITY_EVENTS}/${eventId}`) // Adjust path constant if needed
    .then((result) => result)
    .catch((err) => err.response);
};
